/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
import { alCoerceString, alDefineObjectProperties } from '../runtime';
import { wrapAVM1NativeClass } from './AVM1Utils';
import { AVM1Object } from '../runtime/AVM1Object';
import { AVM1PropertyDescriptor } from '../runtime/AVM1PropertyDescriptor';
var capabilitiesProperties = [
    'avHardwareDisable', 'hasAccessibility', 'hasAudio', 'hasAudioEncoder',
    'hasEmbeddedVideo', 'hasIME', 'hasMP3', 'hasPrinting', 'hasScreenBroadcast',
    'hasScreenPlayback', 'hasStreamingAudio', 'hasStreamingVideo',
    'hasVideoEncoder', 'isDebugger', 'language', 'localFileReadDisable',
    'manufacturer', 'os', 'pixelAspectRatio', 'playerType', 'screenColor',
    'screenDPI', 'screenResolutionX', 'screenResolutionY', 'serverString',
    'version'
];
var AVM1Capabilities = /** @class */ (function (_super) {
    __extends(AVM1Capabilities, _super);
    function AVM1Capabilities(context) {
        var _this = _super.call(this, context) || this;
        _this.alPrototype = context.builtins.Object.alGetPrototypeProperty();
        //var as3Capabilities = context.sec.flash.system.Capabilities.axClass;
        var getter = null;
        var desc = null;
        capabilitiesProperties.forEach(function (name) {
            getter = { alCall: function () { return null; } }; //as3Capabilities.axGetPublicProperty(name); }};
            desc = new AVM1PropertyDescriptor(128 /* AVM1PropertyFlags.ACCESSOR */ |
                2 /* AVM1PropertyFlags.DONT_DELETE */ |
                1 /* AVM1PropertyFlags.DONT_ENUM */, null, getter);
            _this.alSetOwnProperty(name, desc);
        }, _this);
        return _this;
    }
    return AVM1Capabilities;
}(AVM1Object));
var AVM1Security = /** @class */ (function (_super) {
    __extends(AVM1Security, _super);
    function AVM1Security(context) {
        var _this = _super.call(this, context) || this;
        _this.alPrototype = context.builtins.Object.alGetPrototypeProperty();
        alDefineObjectProperties(_this, {
            sandboxType: {
                get: _this.getSandboxType
            },
            allowDomain: {
                value: _this.allowDomain
            },
            allowInsecureDomain: {
                value: _this.allowInsecureDomain
            },
            loadPolicyFile: {
                value: _this.loadPolicyFile
            }
        });
        return _this;
    }
    AVM1Security.prototype.getSandboxType = function () {
        return null; //this.context.sec.flash.system.Security.axClass.sandboxType;
    };
    AVM1Security.prototype.allowDomain = function (domain) {
        domain = alCoerceString(this.context, domain);
        //this.context.sec.flash.system.Security.axClass.allowDomain(domain);
    };
    AVM1Security.prototype.allowInsecureDomain = function (domain) {
        domain = alCoerceString(this.context, domain);
        //this.context.sec.flash.system.Security.axClass.allowInsecureDomain(domain);
    };
    AVM1Security.prototype.loadPolicyFile = function (url) {
        url = alCoerceString(this.context, url);
        //this.context.sec.flash.system.Security.axClass.loadPolicyFile(url);
    };
    return AVM1Security;
}(AVM1Object));
var AVM1System = /** @class */ (function (_super) {
    __extends(AVM1System, _super);
    function AVM1System() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1System.alInitStatic = function (context) {
        this._capabilities = new AVM1Capabilities(context);
        this._security = new AVM1Security(context);
    };
    AVM1System.createAVM1Class = function (context) {
        return wrapAVM1NativeClass(context, false, AVM1System, ['capabilities#', 'security#'], []);
    };
    AVM1System.getCapabilities = function (context) {
        var staticState = context.getStaticState(AVM1System);
        return staticState._capabilities;
    };
    AVM1System.getSecurity = function (context) {
        var staticState = context.getStaticState(AVM1System);
        return staticState._security;
    };
    return AVM1System;
}(AVM1Object));
export { AVM1System };
